import { fetchAuthSession } from 'aws-amplify/auth';
import { getApiUrl } from '../auth/config';

export interface UserProfile {
  userId: string;
  displayName?: string;
  dateOfBirth?: string;
  heightIn?: number;
  weightUnit: 'lbs' | 'kg';
  notifications: {
    enabled: boolean;
    reminderTime?: string;
  };
  updatedAt: string;
}

function apiBase(): string {
  const url = getApiUrl();
  if (!url)
    throw new Error(
      'API URL is not configured. Check VITE_API_URL in .env.local or apiUrl in config.json.',
    );
  return url;
}

async function authHeader(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Not authenticated');
  return `Bearer ${token}`;
}

export async function getProfile(): Promise<UserProfile | null> {
  const res = await fetch(`${apiBase()}/profile`, {
    headers: { Authorization: await authHeader() },
  });
  if (!res.ok) throw new Error(`Failed to fetch profile: ${res.status}`);
  const data = (await res.json()) as Partial<UserProfile>;
  if (!data.userId) return null;
  return data as UserProfile;
}

export async function saveProfile(profile: Omit<UserProfile, 'userId' | 'updatedAt'>): Promise<UserProfile> {
  const res = await fetch(`${apiBase()}/profile`, {
    method: 'PUT',
    headers: {
      Authorization: await authHeader(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(profile),
  });
  if (!res.ok) {
    const body = await res.text();
    throw new Error(`Failed to save profile: ${res.status} ${body}`);
  }
  return (await res.json()) as UserProfile;
}
